module.exports = __webpack_public_path__ + "static/media/product18.6083f462.jpg";